/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is my exact age calculated?`)
};

const es_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula mi edad exacta?`)
};

const de_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird mein genaues Alter berechnet?`)
};

const nl_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt mijn exacte leeftijd berekend?`)
};

const fr_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment mon âge exact est-il calculé ?`)
};

const it_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene calcolata la mia età esatta?`)
};

const pt_br2_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como minha idade exata é calculada?`)
};

const pt_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculada a minha idade exata?`)
};

const ja_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確な年齢はどのように計算されますか？`)
};

const zh_age_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的精确年龄是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq1_q", locale)
	if (locale === "en") return en_age_faq1_q(inputs)
	if (locale === "es") return es_age_faq1_q(inputs)
	if (locale === "de") return de_age_faq1_q(inputs)
	if (locale === "nl") return nl_age_faq1_q(inputs)
	if (locale === "fr") return fr_age_faq1_q(inputs)
	if (locale === "it") return it_age_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq1_q(inputs)
	if (locale === "pt") return pt_age_faq1_q(inputs)
	if (locale === "ja") return ja_age_faq1_q(inputs)
	return zh_age_faq1_q(inputs)
};